// ProductStatsModal.jsx
import React from "react";
import './OrderStatsModal.css';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const ProductStatsModal = ({ data, onClose }) => {
  const chartData = {
    labels: data.map((item) => item.productName),
    datasets: [
      {
        label: 'Order Count',
        data: data.map((item) => parseInt(item.orderCount)),
        backgroundColor: '#FF8000',
        borderRadius: 6,
        barThickness: 24
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 5,
        },
      },
    },
  };

  return (
    <div className="uniq-modal-overlay">
      <div className="uniq-modal-container">
        <div className="uniq-modal-header">
          <h2>Top Ordered Products</h2>
          <button className="uniq-close-btn" onClick={() => onClose()}>✕</button>
        </div>
        <div className="uniq-modal-chart">
          <Bar data={chartData} options={options} />
        </div>
        <div className="uniq-product-list">
          {data.map((product) => (
            <div className="uniq-product-item" key={product.productId}>
              <img className="uniq-product-img" src={product.productImage} alt={product.productName} />
              <div>
                <h4>{product.productName}</h4>
                <p>Orders: {product.orderCount}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductStatsModal;
